import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Environment, IApiRequest, RouterManager } from '@sb/library/base';
import { Observable } from 'rxjs';
import { BaseApiRequestManager } from './base-api-request.manager';

@Injectable({
    providedIn: 'root',
})
export class ApiRequestManager extends BaseApiRequestManager {

    constructor(
        private _HttpClient: HttpClient,
        private _Environment: Environment,
        private _RouterManager: RouterManager
    ) {
        super();
        this._RouterManager.navigating.subscribe(() => {
            // Cancel all requests when navigating
            [...this._inFlight, ...this._requestQueue].filter(request => request.Cancellable).forEach(request => {
                request.Subscription?.unsubscribe();
                request.Subject.complete();
            });

            this._inFlight.clear();
            this._requestQueue = [];
        });
    }

    protected override SendRequest<Result>(request: IApiRequest<any>, reportProgress: boolean): Observable<HttpEvent<Result>> {
        const url = this._Environment.Application.BaseUrls.Api + '/' + request.URL;

        return this._HttpClient.request<Result>(request.Kind, url, {
            body: request.Body,
            params: request.HttpParams,
            observe: 'events',
            reportProgress: reportProgress
        });
    }
}
